import CarerDetail from '../../../_modules/carer-detail/carer-detail';


import { carerDetails } from '../../../_modules/carer-detail/carer-detail';

let $managePatientPage = $('.manage-patient'),
    $primaryContact = $('#PrimaryContact'),
    $carerFirstName = $('#carer-details__form .CarerFirstName'),
    $carerLastName = $('#carer-details__form .CarerLastName'),
    $carerPrimaryNumber = $('#carer-details__form .CarerPrimaryNumber'),
    $carerRelationshipToClient = $('#UpdateCarerRelationshipToClient option'),
    $carerRelationshipToClientDefaultOption = $('select#UpdateCarerRelationshipToClient > option:first-child'),
    isCarerPrimaryContact = false;


$(() => {
    if (!$managePatientPage.length) {
        return false;
    }

    let carerDetailObj = new CarerDetail();
    carerDetailObj.init(),



    $primaryContact.on('change', function () {
        let $this = $(this),
            isChecked = $this.prop('checked');

        isCarerPrimaryContact = isChecked;

        if (isCarerPrimaryContact) {

            $carerFirstName.prev().text($carerFirstName.prev().text() + ' *');
            $carerLastName.prev().text($carerLastName.prev().text() + ' *');
            $carerPrimaryNumber.prev().text($carerPrimaryNumber.prev().text() + ' *');
            $carerRelationshipToClientDefaultOption.text($carerRelationshipToClient.first().text() + ' *');

            $carerFirstName.attr('required', true);
            $carerLastName.attr('required', true);
            $carerPrimaryNumber.attr('required', true);
            $carerRelationshipToClient.attr('required', true);

        } else {
            $carerFirstName.prev().text($carerFirstName.prev().text().replace(' *', ''));
            $carerLastName.prev().text($carerLastName.prev().text().replace(' *', ''));
            $carerPrimaryNumber.prev().text($carerPrimaryNumber.prev().text().replace(' *', ''));
            $carerRelationshipToClientDefaultOption.text($carerRelationshipToClient.first().text().replace(' *', ''));

            $carerFirstName.attr('required', false);
            $carerLastName.attr('required', false);
            $carerPrimaryNumber.attr('required', false);
            $carerRelationshipToClient.attr('required', false);
        }
    });



});

// Deactivate Patient
$('.js-deactivate-client').on('click', function (e){
    e.preventDefault();

	let isMobileDevice = Modernizr.mq('(max-width: 767px)');

	$.fancybox.open('#deactivate-client', {
        autoSize: false,
        closeBtn: false,
        fitToView: false,
        height: isMobileDevice == true ? 300 : 200,
        width: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal',
        afterShow: function(){
            $('.js-agree-deactivate-client').on('click', function (e){
                $.fancybox.close();

                setTimeout(function () {
                    $('#deactivate-client__form').submit();
                }, 100);
            });
        }
    });
});


// Transfer Patient
$('.js-transfer-dropdown').on('click', function (e){
    e.preventDefault();

    $('.transfer-client__dropdown').slideDown({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false,
        complete: function () {
            $('body').addClass('fixed');
        }
    });

});

$('.js-save-client').on('click', function (e) {
    e.preventDefault();

});
